<app-kpi-widget
  [title]="'fuelConsumption.widgets.totalTrips' | transloco"
  [icon]="icon"
  [isLoading]="isLoading"
  [totalValue]="value"
  [percentageDifference]="totalTripsPercentageChange"
  [widgetDisabled]="widgetDisabled"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  [valueFormatter]="formatValue.bind(this)"
  [isUptrendPositive]="true"
  [dropdownEnabled]="false" 
  [hasFooter]="false">
</app-kpi-widget>